import React from "react";
import PropTypes from "prop-types";
import { Card, Accordion } from "react-bootstrap";

import { StyledHeader, StyledContent } from "./AccordionStyles.js";

const AccordionContent = ({
  eventKey,
  element,
  isOpen,
  setIsOpen,
  headerComponent: HeaderComponent,
  contentComponent: ContentComponent,
}) => {
  return (
    <Card>
      <StyledHeader>
        <Accordion.Toggle
          as={Card.Header}
          eventKey={eventKey}
          onClick={() => setIsOpen(eventKey)}
        >
          <HeaderComponent {...element} isOpen={isOpen} eventKey={eventKey} />
        </Accordion.Toggle>
      </StyledHeader>
      <Accordion.Collapse eventKey={eventKey}>
        <StyledContent>
          <ContentComponent {...element} />
        </StyledContent>
      </Accordion.Collapse>
    </Card>
  );
};

AccordionContent.propTypes = {
  eventKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  contentComponent: PropTypes.any.isRequired,
  headerComponent: PropTypes.any.isRequired,
  element: PropTypes.any.isRequired,
};
AccordionContent.defaultProps = {
  eventKey: 0,
};

export default AccordionContent;
